import React from 'react';
import CodeQR from '../../Assets/QrCode.png'
import { useTranslation } from 'react-i18next';
const Modal = ({ open, onClose }) => {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative flex flex-col items-center max-w-lg gap-4 p-6 rounded-md shadow-md sm:py-8 sm:px-12 dark:bg-gray-900 dark:text-gray-100 bg-gray-50 text-gray-800" onClick={e => e.stopPropagation()}>
        <button className="absolute top-2 right-2" onClick={onClose}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="w-6 h-6">
            <polygon points="427.314 107.313 404.686 84.687 256 233.373 107.314 84.687 84.686 107.313 233.373 256 84.686 404.687 107.314 427.313 256 278.627 404.686 427.313 427.314 404.687 278.627 256 427.314 107.313"></polygon>
          </svg>
        </button>
        <img src={CodeQR} alt="Scan" />
        <h2 className="text-2xl font-semibold leading-tight tracking-wide">{t('Modal.Title')}</h2>
        <p className="text-center text-gray-400 dark:text-gray-600">{t('Modal.Description')}</p>
        <button type="button" className="px-8 py-3 font-semibold rounded-full bg-Ripe-mango text-gray-50" onClick={onClose}>{t('Modal.Button')}</button>
      </div>
    </div>
  );
}

export default Modal;
